'use client';

import { c as _c } from "react/compiler-runtime";
import { useSearchParams } from 'next/navigation';
import Script from 'next/script';
import { configPublic } from '@src/config.public';
import { getBuilderPreviewMode } from './builder.util';
export const Ketch = () => {
  const $ = _c(1);
  const searchParams = useSearchParams();
  const edit = searchParams ? getBuilderPreviewMode(Object.fromEntries(searchParams.entries())).edit : false;
  const {
    isEnabled,
    scriptUrl
  } = configPublic.ketch;
  if (edit || !isEnabled) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Script id="ketch-script" strategy="beforeInteractive" dangerouslySetInnerHTML={{
      __html: `!function(){window.semaphore=window.semaphore||[],window.ketch=function(){window.semaphore.push(arguments)};var e=document.createElement("script");e.type="text/javascript",e.src="${scriptUrl}",e.defer=e.async=!0,document.getElementsByTagName("head")[0].appendChild(e)}();`
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};